import { ComponentProps, ReactNode } from 'react';
import { DropdownMenuOption } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import Popover from '../Popover/Popover';
import DropdownMenuItems from './DropdownMenuItems';

type DropdownMenuProps = Pick<
  ComponentProps<typeof Popover>,
  'anchor' | 'className' | 'containerMouseHandlers' | 'isOpen' | 'onCloseRequest' | 'placement' | 'returnFocusOnDeactivate'
> & {
  children?: ReactNode;
  options: DropdownMenuOption[];
  textVariant?: 'text100' | 'text200';
};

const DropdownMenu = ({ children, options, textVariant, ...popoverProps }: DropdownMenuProps) => (
  <Popover {...setDenaliAttribute('DropdownMenu')} {...popoverProps}>
    <DropdownMenuItems className={popoverProps.className} options={options} textVariant={textVariant}>
      {children}
    </DropdownMenuItems>
  </Popover>
);

export default DropdownMenu;
